import { createFileRoute } from "@tanstack/react-router";
import { QuoteLayoutSettingsPage } from "../../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/exports/quote-layout")({
  component: QuoteLayoutSettingsPage,
});
